<template>
  <div class="app-container">
    <el-button
      type="primary"
      plain
      @click="reset()"
      style="margin-bottom: 5px; float: right"
      >重置</el-button
    >
    <el-button
      type="primary"
      @click="(registerUser.page = 1), getRegisteredList()"
      style="margin-bottom: 10px; float: right; margin-right: 10px"
      >搜索</el-button
    >
    <el-select
      filterable
      style="float: right"
      v-model="registerUser.house_id"
      placeholder="请选择房屋"
    >
      <el-option
        :label="item.title"
        :value="item.id"
        v-for="(item, index) in houseList"
        :key="index"
      ></el-option>
    </el-select>
    <el-table
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      v-loading="userLoading"
      :data="registerUserList"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{
            (registerUser.page - 1) * registerUser.page_size + scope.$index + 1
          }}
        </template>
      </el-table-column>
      <el-table-column label="房屋名称">
        <template slot-scope="scope">
          <div class="line2" v-if="scope.row.house">
            {{ scope.row.house.title }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="所属园区" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="申请人">
        <template slot-scope="scope">
          <span>{{ scope.row.user_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="手机号">
        <template slot-scope="scope">
          <span>{{ scope.row.phone }}</span>
        </template>
      </el-table-column>
      <el-table-column label="申请时间">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="registerUser.page"
      :page-sizes="[15, 30, 50]"
      :page-size="registerUser.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="registerUser.total"
      style="margin-top: 10px"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { openPark } from "@/api/index";
import { hire_house_list, intention_user } from "@/api/lease";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl"]),
  },
  data() {
    return {
      token: getToken(),
      registerUser: {
        id: "",
        page: 1,
        page_size: 15,
        total: 0,
        house_id: "",
      },
      registerUserList: [],
      userLoading: true,
      houseList: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.registerUser.park_id = this.userInfo.park_id;
    } else {
      this.registerUser.park_id = "";
    }
    // this.fetchData();
    this.getHouse();
    this.getRegisteredList();
  },
  methods: {
    getRegisteredList() {
      intention_user(this.registerUser).then((res) => {
        this.userLoading = false;
        this.dialogVisible = true;
        this.registerUserList = res.data.lists.data;
        this.registerUser.page = res.data.lists.current_page;
        this.registerUser.total = res.data.lists.total;
      });
    },
    reset() {
      this.registerUser = {
        id: "",
        page: 1,
        page_size: 15,
        total: 0,
        house_id: "",
      };
      this.getRegisteredList();
    },
    handleSizeChange(val) {
      this.registerUser.page_size = val;
      this.registerUser.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.registerUser.page = val;
      this.fetchData();
    },
    // 获取园区
    getHouse() {
      let data = {
        park_id: "",
      };
      if (this.userInfo.park_id !== 0) {
        data.park_id = this.userInfo.park_id;
      } else {
        data.park_id = "";
      }
      this.houseList = [];
      hire_house_list(data).then((res) => {
        this.houseList = res.data.lists.data;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
